module.exports = __webpack_public_path__ + "img/TypingPageTitleBackground.9ec9d33b.png";